import axios from 'axios'

// export const API_URL = `/api`
export const API_URL = '/api/v1/front/'

const instance = axios.create({
  baseURL: API_URL,
  timeout: 90000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export default instance
